import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";
import { StaffType } from "../types/StaffType";

export default function useDragStaff() {
  const queryClient = useQueryClient();
  const { data: staff }: any = useQuery(queryKeys.staffDrag, () =>
    queryClient.getQueryData(queryKeys.staffDrag)
  );
  const setStaffDrag = useCallback(
    (staff: StaffType | null) =>
      queryClient.setQueryData(queryKeys.staffDrag, staff),
    [queryClient]
  );

  return { staff: staff || null, setStaffDrag };
}
